
export const isInvalidoCodigoContainer = (string) => {
    if (string && string.length>0) {
        const regex = /^[a-zA-Z]{4}[0-9]{7}$/;
        return (regex.test(string)) ? false : "Formato inválido";
    } else return false;
};

export const isInvalidoPlacas = (string) => {
    if (string && string.length>0) {
        const regex = /^[a-zA-Z]{3}[0-9]{1}([a-zA-Z]|[0-9])[0-9]{2}$/;
        return (regex.test(string)) ? false : "Formato inválido";
    } else return false;
};

export const isInvalidoTam5 = (string) => {
    if (string && string.length>0) {
        const regex = /^[0-9]{5}$/;
        return (regex.test(string)) ? false : "Apenas 5 dígitos";
    } else return false;
};

export const quantidadeMaxChar = (string, qtd) => {
    if(string && string.length > qtd){
       return "No maxímo "+qtd+" caracteres";
    }
   return false
};

export const quantidadeMinChar44 = (string) => {
    if(string && string.length < 44){
       return "Campo deve ter conter 44 posições númericas";
    }
   return false
};

export const isNotAlphanumeric = (string) => {
    if(string && string.length > 0){
        const regex = new RegExp("^[A-Za-z0-9_-]+$")
        return (regex.test(string) ? false : "Caracteres especiais não são permitidos")
    }else return false
}

export const isEmail = (string) => {
    if (string && string.length > 0) {
        const regex = /^[\w\-\.]+@([\w\-]+\.)+[\w\-]{2,4}$/gm;

        return regex.test(string)
    }
    return false;
}

export const isInvalidoChaveNFe = (string, { validarCnpj = false } = {}) => {
  if (!string || string.length === 0) return false;

  // 1) Só números e 44 dígitos
  if (!/^\d{44}$/.test(string)) {
    return "A chave deve conter exatamente 44 dígitos numéricos";
  }

  // 2) Decomposição
  const uf          = string.substring(0, 2);
  const aamm        = string.substring(2, 6);   // AAMM
  const cnpj        = string.substring(6, 20);  // 14
  const modelo      = string.substring(20, 22); // 55 para NF-e
  const serie       = string.substring(22, 25); // 3
  const numero      = string.substring(25, 34); // 9
  const tpEmis      = string.substring(34, 35); // 1
  const codNumerico = string.substring(35, 43); // 8
  const dvInformado = Number(string.substring(43, 44));

  // 3) Regras de campo
  const ufVal = Number(uf);
  if (ufVal < 1 || ufVal > 53) return "UF inválida (deve estar entre 01 e 53)";

  const aa = Number(aamm.substring(0, 2));
  const mm = Number(aamm.substring(2, 4));
  if (mm < 1 || mm > 12) return "Mês inválido na chave (AAMM)";

  if (modelo !== "55") return "Modelo inválido (esperado 55 para NF-e)";

  // série e número já têm tamanho fixo; só checa numérico (já garantido)
  // tpEmis 1–9
  const tp = Number(tpEmis);
  if (tp < 1 || tp > 9) return "tpEmis inválido (deve estar entre 1 e 9)";

  // código numérico: já garantido como 8 dígitos

  // (Opcional) validar DV do CNPJ do emitente
  if (validarCnpj && !isCnpjValido(cnpj)) return "CNPJ do emitente inválido";

  // 4) DV Módulo 11 (pesos 2..9 da direita para a esquerda sobre os 43 primeiros dígitos)
  const dvCalculado = dvMod11NFe(string.substring(0, 43));
  if (dvCalculado !== dvInformado) return "Dígito verificador da chave inválido";

  return false;
};

// ----------------- Helpers -----------------

// Cálculo do DV da chave NF-e (43 dígitos) com módulo 11
function dvMod11NFe(s43) {
  let peso = 2;
  let soma = 0;
  for (let i = s43.length - 1; i >= 0; i--) {
    soma += Number(s43[i]) * peso;
    peso = (peso === 9) ? 2 : peso + 1;
  }
  const resto = soma % 11;
  const dv = 11 - resto;
  return (dv === 10 || dv === 11) ? 0 : dv;
}

// Validador simples de CNPJ (caso queira ligar a opção validarCnpj)
function isCnpjValido(cnpj) {
  if (!/^\d{14}$/.test(cnpj)) return false;

  // Rejeita sequências repetidas
  if (/^(\d)\1{13}$/.test(cnpj)) return false;

  const calcDv = (base) => {
    let soma = 0;
    let peso = base.length === 12 ? 5 : 6; // primeiro DV começa em 5; segundo em 6
    for (let i = 0; i < base.length; i++) {
      soma += Number(base[i]) * peso;
      peso = (peso === 2) ? 9 : peso - 1;
    }
    const resto = soma % 11;
    return (resto < 2) ? 0 : 11 - resto;
  };

  const dv1 = calcDv(cnpj.substring(0, 12));
  const dv2 = calcDv(cnpj.substring(0, 12) + dv1);

  return cnpj.endsWith(`${dv1}${dv2}`);
}

// Valida chave de acesso CT-e (modelo 57 por padrão) – apenas formato/padrão (sem consultar SEFAZ)
// Retorna false se válida; caso contrário, uma mensagem de erro.
export const isInvalidoChaveCTe = (
  string,
  { aceitarModelos = ["57"], validarCnpj = false } = {}
) => {
  if (!string || string.length === 0) return false;

  // 1) Só números e 44 dígitos
  if (!/^\d{44}$/.test(string)) {
    return "A chave deve conter exatamente 44 dígitos numéricos";
  }

  // 2) Decomposição (igual NF-e, mas modelo é 57/67)
  const uf          = string.substring(0, 2);
  const aamm        = string.substring(2, 6);   // AAMM
  const cnpj        = string.substring(6, 20);  // 14
  const modelo      = string.substring(20, 22); // 57 (CT-e) ou 67 (CT-e OS)
  const serie       = string.substring(22, 25); // 3
  const numero      = string.substring(25, 34); // 9
  const tpEmis      = string.substring(34, 35); // 1
  const cct         = string.substring(35, 43); // 8 (cCT - código numérico)
  const dvInformado = Number(string.substring(43, 44));

  // 3) Regras de campo
  const ufVal = Number(uf);
  if (ufVal < 1 || ufVal > 53) return "UF inválida (deve estar entre 01 e 53)";

  const mm = Number(aamm.substring(2, 4));
  if (mm < 1 || mm > 12) return "Mês inválido na chave (AAMM)";

  if (!aceitarModelos.includes(modelo))
    return `Modelo inválido (esperado ${aceitarModelos.join(" ou ")})`;

  // tpEmis 1–9 (CT-e admite vários tipos de emissão; aqui validamos faixa simples)
  const tp = Number(tpEmis);
  if (tp < 1 || tp > 9) return "tpEmis inválido (deve estar entre 1 e 9)";

  // (Opcional) Validar DV do CNPJ do emitente
  if (validarCnpj && !isCnpjValido(cnpj)) return "CNPJ do emitente inválido";

  // 4) DV Módulo 11 (pesos 2..9 da direita para a esquerda sobre os 43 primeiros dígitos)
  const dvCalculado = dvMod11CTe(string.substring(0, 43));
  if (dvCalculado !== dvInformado) return "Dígito verificador da chave inválido";

  return false;
};

// ----------------- Helpers -----------------

function dvMod11CTe(s43) {
  let peso = 2;
  let soma = 0;
  for (let i = s43.length - 1; i >= 0; i--) {
    soma += Number(s43[i]) * peso;
    peso = (peso === 9) ? 2 : peso + 1;
  }
  const resto = soma % 11;
  const dv = 11 - resto;
  return (dv === 10 || dv === 11) ? 0 : dv;
}


// WEBPACK FOOTER //
// ./src/utils/validadores.js